// dr8-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "; importe de novo para remover o resto.": "; importe de nuevo para quitar el resto.",
    "Aguarde…": "Espere…",
    "Arquivo .csv, .xlsx ou .xls com a coluna CPF, com ou sem pontuação. Nome é opcional. Até 20.000 linhas.": "Archivo .csv, .xlsx o .xls con la columna CPF, con o sin puntuación. El nombre es opcional. Hasta 20.000 filas.",
    "Baixar modelo": "Descargar modelo",
    "Escolher arquivo": "Elegir archivo",
    "Importar CPFs": "Importar CPFs",
    "Importar CPFs na etiqueta": "Importar CPFs en la etiqueta",
    "Importação concluída: %{arg1}, %{arg2} na etiqueta, %{arg3}.": "Importación concluida: %{arg1}, %{arg2} en la etiqueta, %{arg3}.",
    "Nenhum CPF válido no arquivo.": "Ningún CPF válido en el archivo.",
    "Nenhuma linha encontrada no arquivo": "No se encontró ninguna fila en el archivo",
    "Os nomes não aparecem porque o seu perfil não tem a permissão Listar clientes.": "Los nombres no aparecen porque su perfil no tiene el permiso Listar clientes.",
    "Prévia, nada foi gravado.": "Vista previa, no se guardó nada.",
    "Quem ainda não se cadastrou entra como pré-cadastro e continua na etiqueta quando se cadastrar no app. Pré-cadastro fica sem celular, então SMS para esta etiqueta não chega nele.": "Quien aún no se registró entra como prerregistro y sigue en la etiqueta cuando se registre en la app. El prerregistro queda sin celular, así que el SMS para esta etiqueta no le llega.",
    "Remover da etiqueta %{arg1} nesta lista": "Quitar de la etiqueta %{arg1} en esta lista",
    "Sem nome": "Sin nombre",
    "e mais": "y otros",
    "pessoas não estão na lista. Esta importação remove as primeiras": "personas no están en la lista. Esta importación quita las primeras",
};

export default catalogo;
